import { useCallback } from 'react'
import {
  MeetingStartTimes,
  AvailabilityOptions,
  SelectTimeSlotParams,
} from '../../load-availability-options'
import { getAvailableAssigneesForSlot } from '../helpers'

export const useSelectTimeSlot = (
  timeSlots?: MeetingStartTimes,
  availabilityOptions?: AvailabilityOptions,
  timezone?: string
) => {
  return useCallback(
    (slot: string) => {
      if (!availabilityOptions || !timeSlots) {
        return {
          slot,
          timezone,
          userIds: [],
          availableRoundRobinAssignees: [],
        }
      }

      const { userIds, availableRoundRobinAssignees } = getAvailableAssigneesForSlot({
        slot,
        timeSlots,
      })

      return {
        slot,
        userIds,
        availableRoundRobinAssignees,
        timezone,
      } satisfies SelectTimeSlotParams
    },
    [timeSlots, availabilityOptions, timezone]
  )
}
